import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useIdleStore } from "../../store/useIdleStore";

export default function IdleModal() {
  const { showIdlePopup, countdown, resetIdle, logout } = useIdleStore();

  if (!showIdlePopup) return null;

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <Modal isOpen={showIdlePopup} toggle={resetIdle} centered={true} backdrop="static">
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-warning text-warning bg-opacity-10 font-size-24 rounded-3">
              <i className="mdi mdi-clock-outline"></i>
            </div>
          </div>
          <h4 className="text-dark font-size-18 mb-2">Session Expiring</h4>
          <p className="text-muted font-size-14 mb-3">
            You have been inactive for a while. Please click on continue to resume your session.
          </p>
          <p className="text-muted font-size-14 mb-1">You will be logged out in</p>
          <div className="text-danger font-size-30 font-weight-bold mb-4">
            {minutes}:{seconds.toString().padStart(2, "0")}
          </div>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={resetIdle}
            >
              Continue
            </button>
            <button
              type="button"
              className="btn btn-danger px-4"
              onClick={logout}
            >
              Logout
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  );
}
